import { SkullCrossbonesIcon } from './SkullCrossbonesIcon';

/**
 * author: Michael Irigoyen
 * id C85F31B5-3C18-480D-B3A6-7F4FB7095273
 * name skull-crossbones
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skull-crossbones.svg
 * tags
 * - Gaming / RPG 
 * - Holiday 
 */
export const JollyRogerIcon = SkullCrossbonesIcon;
export default JollyRogerIcon